import { useDatasourceSpace } from './datasources/space'
import { useDatasourceAudio } from './datasources/audio'
import { useDatasourceDynamicContent } from './datasources/dynamic-content'
import { useIsClient } from './use-role'

export function useDatasources() {
  const isClient = useIsClient()

  // Toujours chargé : la liste des espaces est scopée côté API, un client n'y
  // voit que les siens.
  useDatasourceSpace()

  // Audios, livres, ambiances et catégories sont gardés par AdminAccess côté
  // API, et le contenu dynamique vit dans Firestore, hors de portée d'un compte
  // client. Les interroger déclencherait des erreurs en boucle.
  useDatasourceAudio(!isClient)
  useDatasourceDynamicContent(!isClient)
}
